import { useContext } from 'react';
import { ToastContext } from '../contexts/toast-context-provider';
// Adjust path as needed

function useCopyId() {
  const { showToast } = useContext(ToastContext);

  const copyId = async (e, { id, message }) => {
    e.preventDefault();
    e.stopPropagation();
    navigator.clipboard.writeText(id);
    showToast(message);
  };

  return copyId;
}

export default useCopyId;
